import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import React from "react";

const CancelIcon = (props) => <FontAwesomeIcon icon={["fas", "window-close"]} {...props}/>

export default CancelIcon;